import React from 'react'

import { withRouter } from 'react-router-dom'

import { DataTable } from 'primereact/datatable' 
import { Column } from 'primereact/column'
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { Dialog } from 'primereact/dialog'
import { Dropdown } from 'primereact/dropdown'
import { MultiSelect } from 'primereact/multiselect'
import { InputText } from 'primereact/inputtext'
import { InputMask } from 'primereact/inputmask';
import { InputNumber } from 'primereact/inputnumber'
import { AutoComplete } from 'primereact/autocomplete';
import { InputTextarea } from 'primereact/inputtextarea'
import { Calendar } from 'primereact/calendar'
import { TabView, TabPanel } from 'primereact/tabview';
import { Accordion, AccordionTab } from 'primereact/accordion'
import { locale, addLocale, updateLocaleOption, updateLocaleOptions, localeOption, localeOptions } from 'primereact/api'
import { RadioButton } from 'primereact/radiobutton'
import { Checkbox } from 'primereact/checkbox'
import { SelectButton } from 'primereact/selectbutton'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import { uniqueId } from "lodash"
import filesize from 'filesize'

import NavBar from '../../componentes/Navbar'
import Upload from '../../componentes/Upload/Index'
import FileList from '../../componentes/FileList/index'

import PessoaService from '../../app/service/PessoaService'
import LocalStorageService from '../../app/service/localStorageService'
import GrupoPessoasUsuariosService from '../../app/service/GrupoPessoasUsuariosService'
import GrupoPessoasService from '../../app/service/GruposPessoasService'
import EstadoService from '../../app/service/EstadoService'
import CidadeService from '../../app/service/CidadeService'
import UploadPessoaService from '../../app/service/UploadPessoaService'
import ArquivoPessoaService from '../../app/service/ArquivoPessoaService'
import UnidadeAtendimentoService from '../../app/service/UnidadeAtendimentoService'

import { AuthContext } from '../../main/ProvedorAutenticacao'

import Logo from '../../pages/seguranca/img/admin_gear.png'
import './pessoa.css'

class CadastrarPessoa extends React.Component {
  constructor(props) {
    super(props);

    this.pessoaService = new PessoaService();
    this.grupoPessoaUsuariosService = new GrupoPessoasUsuariosService();
    this.grupoPessoasService = new GrupoPessoasService();
    this.estadoService = new EstadoService();
    this.cidadeService = new CidadeService();
    this.uploadPessoaService = new UploadPessoaService();
    this.arquivoPessoaService = new ArquivoPessoaService();
    this.unidadeAtendimentoService = new UnidadeAtendimentoService();

    this.acoesArquivos = this.acoesArquivos.bind(this);
    this.renderFooterDescricaoArquivo = this.renderFooterDescricaoArquivo.bind(this);
    this.onChangeTipoPessoa = this.onChangeTipoPessoa.bind(this);
    this.onChangePerfil = this.onChangePerfil.bind(this);
    this.onChangeEstadoCivil = this.onChangeEstadoCivil.bind(this);
    this.onChangeTipoEndereco = this.onChangeTipoEndereco.bind(this);
    this.onChangeEstado = this.onChangeEstado.bind(this);
    this.onChangeCidade = this.onChangeCidade.bind(this);
    this.onChangeEstadoCivil = this.onChangeEstadoCivil.bind(this);
    this.onChangeTipoConta = this.onChangeTipoConta.bind(this);
    this.onChangeCaptador = this.onChangeCaptador.bind(this);
    this.onChangeGrupoPessoas = this.onChangeGrupoPessoas.bind(this);

    this.state = {
      pessoa: null,
      codigo: '',
      nome: '',
      labelNome: '',
      tipoPessoa: null,
      perfil: null,
      perfis: [],
      dataNascimento: '',
      profissao: '',
      atividadeEconomica: '',
      estadoCivil: null,
      estadosCivil: [],
      cpfCnpj: '',
      rg: '',
      senhaInss: '',
      passaporte: '',
      tituloEleitor: '',
      reservista: '',
      pis: '',
      cnh: '',
      ctps: '',
      nomeMae: '',
      nomePai: '',
      naturalidade: '',
      nacionalidade: '',
      email: '',
      telefone: '',
      telefone2: '',
      endereco: '',
      numero: '',
      tipoEndereco: null,
      tipoContato: null,
      bairro: '',
      cep: '',
      estado: null,
      estados: [],
      cidade: null,
      cidades: [],
      contaCorrente: '',
      tipoConta: null,
      agencia: '',
      banco: '',
      variacaoPoupanca: '',
      pix: '',
      observacao: '',
      status: '',
      classeDiv: '',
      detail: '',
      grupoPessoas: [],
      selectGrupoPessoas: null,
      defineTipoPessoa: {},
      defineTipoPessoaJuridica: {},
      //Arquivos
      upLoadFiles: [],
      nome: '',
      descricao: '',
      arquivos: [],
      modalDescricaoArquivo: false,
      arquivo: null,
      arquivoCodigo: '',
      visibleExcluirArquivo: false,
      captadores: [],
      captador: null,
      openSpinner: false,
      //Unidade de Atendimento
      unidades: [],
      unidade: null,
      //Novo Endereçamento e Contatos
      enderecos: [],
      contatos: [],
      modalEndereco: false,
      modalContato: null,
      labelModal: '',
      contatoTelefonico: '',
    };

    this.tipoEndereco = [
      {codigo: 'RUA', nome: 'RUA'},
      {codigo: 'AVENIDA', nome: 'AVENIDA'},
      {codigo: 'TRAVESSA', nome: 'TRAVESSA'},
      {codigo: 'PRACA', nome: 'PRACA'},
      {codigo: 'RODOVIA', nome: 'RODOVIA'},
      {codigo: 'ESTRADA', nome: 'ESTRADA'},
      {codigo: 'ALAMEDA', nome: 'ALAMEDA'},
      {codigo: 'LARGO', nome: 'LARGO'},
      {codigo: 'BECO', nome: 'BECO'},
      {codigo: 'VIA', nome: 'VIA'}
    ];

    this.tipoContato = [
      {codigo: 'CELULAR', nome: 'CELULAR'},
      {codigo: 'FIXO', nome: 'FIXO'},
      {codigo: 'WHATSAPP', nome: 'WHATSAPP'}
    ]

    this.conta = [
      {codigo: 'C', nome: 'Conta Corrente'},
      {codigo: 'P', nome: 'Poupança'}
    ]

    addLocale('es', {
      firstDayOfWeek: 1,
      dayNames: ['Domingo', 'Domingo', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      dayNamesShort: ['Domingo', 'Domingo', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      dayNamesMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
      monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Stembro', 'Outubro', 'Novembro', 'Dezemro'],
      monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      today: 'Hoy',
      clear: 'Claro'
    });
  }

  onChangeTipoConta(e) {
    this.setState({tipoConta: e.value})
  }

  onChangeCaptador(e) {
    this.setState({captador: e.value});
  }

  onChangeGrupoPessoas(e) {
    this.setState({selectGrupoPessoas: e.value});
  }

  listarUnidadesAtendimento = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.unidadeAtendimentoService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({unidades: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Cadastro de Pessoas - Unidades de Atendimento', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarGruposPessoas = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.grupoPessoasService.listarGrupos(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({grupoPessoas: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Cadastro de Pessoas - Consulta de Grupo de Pessoas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarCaptadores = () => {
    const usuarioLogado = this.context.usuarioAutenticado
    this.pessoaService.listarCaptadores('CP', usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({captadores: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Cadastro de Pessoas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  onChangeDefineTipoPessoa = () => {
    if(this.state.tipoPessoa === 'J') {
      this.setState({defineTipoPessoa: {
        display: 'none'
      }});
      this.setState({defineTipoPessoaJuridica: {
        display: 'block'
      }});
      this.setState({labelNome: 'Empresa'});
    } else {
      this.setState({defineTipoPessoa: {
        display: 'block'
      }});
      this.setState({defineTipoPessoaJuridica: {
        display: 'none'
      }});
      this.setState({labelNome: 'Nome'});
    }
  }

  async onChangeTipoPessoa(e) {
    await this.setState({tipoPessoa: e.value});
    this.onChangeDefineTipoPessoa();
  }

  pad2 = (n) => {
    return (n < 10 ? '0' : '') + n;
  }

  cadastrarPessoa = async () => {
    this.setState({classeDiv: 'show'});

    const usuarioLogado = this.context.usuarioAutenticado

    if(this.state.tipoPessoa == null) {
      this.toast.show({severity:'error', summary: 'Cadastro de Pessoas', detail:'Informe o tipo de Pessoa', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Cadastro de Pessoas', detail:'Informe o nome da Pessoa', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    if(this.state.perfil == null) {
      this.toast.show({severity:'error', summary: 'Cadastro de Pessoas', detail:'Informe o perfil da Pessoa', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    if(this.state.cidade == null) {
      this.toast.show({severity:'error', summary: 'Cadastro de Pessoas', detail:'Informe a Cidade', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    if(this.state.perfil.codigo == 'CP' || this.state.perfil.codigo == 'AD') {
      this.toast.show({severity:'error', summary: 'Cadastro de Pessoas', detail:'Captadores e Advogados não possuem captadores', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    //Data de nascmento
    var dataFormatadaDataNascimento = '';
    if(this.state.dataNascimento != '' && this.state.dataNascimento != null) {
      var date = this.state.dataNascimento;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataFormatadaDataNascimento =  year+"-"+month+"-"+day;
    }
    
    this.setState({openSpinner: true});
    await this.pessoaService.cadastrarPessoa({
      tipoPessoa: this.state.tipoPessoa,
      nome: this.state.nome,
      perfil: this.state.perfil,
      dataNascimento: dataFormatadaDataNascimento,
      profissao: this.state.profissao,
      atividadeEconomica: this.state.atividadeEconomica,
      estadoCivil: this.state.estadoCivil,
      cpfCnpj: this.state.cpfCnpj,
      rg: this.state.rg,
      senhaSerasa: this.state.senhaInss,
      passaporte: this.state.passaporte,
      tituloEleitor: this.state.tituloEleitor,
      reservista: this.state.reservista,
      pis: this.state.pis,
      cnh: this.state.cnh,
      ctps: this.state.ctps,
      nomeMae: this.state.nomeMae,
      nomePai: this.state.nomePai,
			grupoCliente: this.state.selectGrupoPessoas,
      naturalidade: this.state.naturalidade,
      nacionalidade: this.state.nacionalidade,
      tipoConta: null,//this.state.tipoConta.codigo,
      contaCorrente: this.state.contaCorrente,
      agencia: this.state.agencia,
      banco: this.state.banco,
      pix: this.state.pix,
      observacao: this.state.observacao,
      empresa: usuarioLogado.empresa,
      enderecos: this.state.enderecos,
      contatos: this.state.contatos,
      unidadeAtendimento: this.state.unidade,
      variacaoPoupanca: this.state.variacaoPoupanca,
      usuario: usuarioLogado.codigo
    }).then(response => {
      //this.toast.show({severity:'success', summary: 'Cadastro de Pessoas', detail:'Pessoa cadastrada com sucesso!', life: 4000});
      //this.limparCamposCadastro();
      //this.listarArquivosTemp();
      //this.setState({openSpinner: false});
      this.consultarPessoas(response.data.nome);
    }).catch(error => {
      this.setState({openSpinner: false});
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Cadastro de Pessoas', detail:`${this.state.detail}`, life: 4000});
    })
  }


  consultarPessoas = async(nome) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const filtro = {
      nome: nome,
      empresa: usuarioLogado.empresa.codigo,
      usuario: usuarioLogado.codigo,
    }

    this.setState({openSpinner: true});
    await this.pessoaService.consultarPessoas(filtro)
      .then(response => {
        LocalStorageService.adicionarConsulta('_consulta_pessoa_filtro', filtro);
        window.open('/#/pessoas/');
      }).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Pessoas', detail:`${this.state.detail}`, life: 4000});
      });

      this.setState({openSpinner: false});
      this.op.hide();
  }




  limparCamposCadastro = () => {
    this.setState({nome: ''});
    this.setState({tiipoPessoa: 'F'});
    this.setState({perfil: null});
    this.setState({dataNascimento: ''});
    this.setState({profissao: ''});
    this.setState({atividadeEconomica: ''});
    this.setState({estadoCivil: null});
    this.setState({cpfCnpj: ''});
    this.setState({rg: ''});
    this.setState({passaporte: ''});
    this.setState({tituloEleitor: ''});
    this.setState({reservista: ''});
    this.setState({pis: ''});
    this.setState({cnh: ''});
    this.setState({ctps: ''});
    this.setState({nomeMae: ''});
    this.setState({nomePai: ''});
    this.setState({naturalidade: ''});
    this.setState({nacionalidade: ''});
    this.setState({tipoConta: null});
    this.setState({contaCorrente: ''});
    this.setState({agencia: ''});
    this.setState({banco: ''});
    this.setState({pix: ''});
    this.setState({observacao: ''});
    this.setState({captador: null});
    this.setState({selectGrupoPessoas: null});
    this.listarCaptadores();
  }

  pesquisar = () => {
    this.props.history.push('/pessoas')
  }

  componentDidMount() {
    this.excluirArquivos();
    this.setState({tipoPessoa: 'F'})
    this.setState({defineTipoPessoa: {
      display: 'block'
    }});
    this.setState({defineTipoPessoaJuridica: {
      display: 'none'
    }});
    this.setState({labelNome: 'Nome'});

    this.listarPerfisPessoa();
    this.listarGruposPessoas();
    this.listarCaptadores();
    this.listarEstadosCivil();
    this.listarTiposEndereco();
    this.listarEstados();
    this.listarUnidadesAtendimento();
  }

  onChangeDefineTipoPessoa = () => {
    if(this.state.tipoPessoa === 'J') {
      this.setState({defineTipoPessoa: {
        display: 'none'
      }});
      this.setState({defineTipoPessoaJuridica: {
        display: 'block'
      }});
      this.setState({labelNome: 'Empresa'});
    } else {
      this.setState({defineTipoPessoa: {
        display: 'block'
      }});
      this.setState({defineTipoPessoaJuridica: {
        display: 'none'
      }});
      this.setState({labelNome: 'Nome'});
    }
  }

  //Upload de Documentos
  handleUpload = async files => {
    const upLoadFiles = files.map(file => ({
      file,
      id: uniqueId(),
      name: file.name,
      readableSize: filesize(file.size),
      progress: 0,
      uploaded: false, 
      error: false,
      url: file.url
    }))

    this.setState({
      upLoadFiles: this.state.upLoadFiles.concat(upLoadFiles)
    });

    await upLoadFiles.forEach(this.processar);
  }

  updateFile = (id, data) => {
    this.setState({upLoadFiles: this.state.upLoadFiles.map(upLoadFile => {
      return id === upLoadFile.id ? { ...upLoadFile, ...data } : upLoadFile;
    })})
  }

  processar = async (upLoadFile) => {
    const usuarioLogado = this.context.usuarioAutenticado
    const data = new FormData();
    data.append('file',upLoadFile.file);
    data.append('usuario',upLoadFile.file, usuarioLogado.codigo) //Envia código de usuário para guardar arquivos
    await this.arquivoPessoaService.incluirArquivoTemp(data)
      .then(response => {
        this.listarArquivosTemp();
        this.handleDelete(upLoadFile.id);
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  handleDelete  = async id => {
    this.setState({upLoadFiles: this.state.upLoadFiles.filter(file => file.id !== id)});
  } 

  listarArquivosTemp = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.arquivoPessoaService.listarArquivosTemp(usuarioLogado.codigo)
      .then(response => {
        this.setState({arquivos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  excluirArquivo = (rowData) => {
    this.arquivoPessoaService.excluirArquivoTemp(rowData.codigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Arquivos', detail:'Arquivo excluído com sucesso', life: 4000});
        this.listarArquivosTemp();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  excluirArquivos = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.arquivoPessoaService.excluirArquivosTemp(usuarioLogado.codigo)
      .then(response => {
        console.log('Arquivos temporários excluídos');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${error}`, life: 4000});
      })
  }

  async download (rowData){
    await this.consultarArquivo(rowData.codigo);
    await this.arquivoPessoaService.downloadTemp(rowData.codigo)
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.state.arquivo.arquivo); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  }

  consultarArquivo = async (codigo) => {
    await this.arquivoPessoaService.consultarArquivoTemp(codigo)
      .then(response => {
        this.setState({arquivo: response.data});
        this.setState({descricao: response.data.descricao});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${error}`, life: 4000});
      })
  }

  async consultarArquivoDescricao(rowData) {
    await this.arquivoPessoaService.consultarArquivoTemp(rowData.codigo)
      .then(response => {
        this.setState({arquivo: response.data});
        this.setState({descricao: response.data.descricao});
        this.abrirModalDescricaoArquivo('modalDescricaoArquivo');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${error}`, life: 4000});
      })
  }

  acoesArquivos(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-comment" className="p-button-rounded p-button-text"
                tooltip="Adicionar descrição ao arquivo"
                tooltipOptions={{position: 'top'}}
                onClick={() => this.consultarArquivoDescricao(rowData)}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-cloud-download" className="p-button-rounded p-button-text"
                tooltip="Baixar Arquivo"
                onClick={() => this.download(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Arquivo"
                onClick={() => this.excluirArquivo(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  abrirModalDescricaoArquivo(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  fecharModalCadastro(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  renderFooterDescricaoArquivo(name) {
    return (
        <div>
            <button type="button" 
                    className="btn btn-primary bg-gradient-secondary" 
                    onClick={() => this.fecharModalCadastro(name)}>
                <i className="fas fa-times"></i> Cancelar
            </button>
            <button type="button" className="btn btn-primary bg-gradient-success"
                    onClick={this.adicionarDescricao}>
                <i className="fas fa-check"></i> Alterar
            </button>
        </div>
    );
  }

  adicionarDescricao = () => {
    this.arquivoPessoaService.adicionarDescricaoTemp({
      codigo: this.state.arquivo.codigo,
      descricao: this.state.descricao
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Arquivos', detail:'Descrição adicionada com sucesso', life: 4000});
      this.listarArquivosTemp();
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
    });

    this.fecharModalCadastro('modalDescricaoArquivo');
  }

  //Listas
  listarPerfisPessoa = async () => {
    await this.pessoaService.listarPerfilPessoa()
      .then(response => {
        this.setState({perfis: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Pessoas', detail:'Erro ao listar tipos de perfis de pessoa', life: 4000});
      })
  }

  onChangePerfil(e) {
    this.setState({perfil: e.value});
  }

  listarEstadosCivil = async () => {
    await this.pessoaService.listarEstadoCivil()
      .then(response => {
        this.setState({estadosCivil: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Pessoas', detail:'Erro ao listar tipos de estados civis', life: 4000});
      })
  }

  onChangeEstadoCivil(e) {
    this.setState({estadoCivil: e.value});
  }

  listarTiposEndereco = async () => {
    await this.pessoaService.listarTiposEndereco()
      .then(response => {
        this.setState({tiposEndereco: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Pessoas', detail:'Erro ao listar tipos de endereço', life: 4000});
      })
  }

  onChangeTipoEndereco(e) {
    this.setState({tipoEndereco: e.value});
  }

  onTipoPessoaChange(e) {
    this.setState({tipoPessoa: e.value});
  }

  listarEstados = async () => {
    this.estadoService.listarEstados()
      .then(response => {
        this.setState({estados: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Pessoas', detail:'Erro ao listar Estados', life: 4000});
      });
  }

  async onChangeEstado(e) {
    if(e.value != null) {
      await this.setState({estado: e.value});
      this.setState({openSpinner: true});
      await this.listarCidades();
      this.setState({openSpinner: false});
    } else {
      this.setState({estado: null});
      this.setState({cidade: null});
      this.setState({cidades: []});
    }
  }

  listarCidades = () => {
    this.cidadeService.listarCidades(this.state.estado.codigo)
      .then(response => {
        this.setState({cidades: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Pessoas', detail:'Erro ao listar Cidades', life: 4000});
      })
  }

  onChangeCidade(e) {
    this.setState({cidade: e.value});
  }

  onChangeEstadoCivil(e) {
    this.setState({estadoCivil: e.value});
  }

  voltar = () => {
    const consultaFiltro = LocalStorageService.obterConsulta('_consulta_pessoa_filtro');
    const consultaFiltroJson = JSON.parse(consultaFiltro);

    if(consultaFiltroJson != null) {
      let params = `/pessoas?empresa=${consultaFiltroJson.empresa}&usuario=${consultaFiltroJson.usuario}`;
      
      if(consultaFiltroJson.nome != null) {
        params = `${params}&nome=${consultaFiltroJson.nome}`;
      }
  
      if(consultaFiltroJson.cpfCnpj != null) {
        params = `${params}&cpfCnpj=${consultaFiltroJson.cpfCnpj}`;
      }
  
      if(consultaFiltroJson.cidade != null) {
        params = `${params}&cidade=${consultaFiltroJson.cidade}`;
      }
  
      if(consultaFiltroJson.telefone != null) {
        params = `${params}&telefone=${consultaFiltroJson.telefone}`;
      }
  
      if(consultaFiltroJson.porLetra != null) {
        params = `${params}&letra=${consultaFiltroJson.letra}&porLetra=${consultaFiltroJson.porLetra}`;
      }
  
      if(consultaFiltroJson.grupo != null) {
        params = `${params}&grupo=${consultaFiltroJson.grupo}`;
      }

      this.props.history.push(params);

    } else {
      this.props.history.push('/pessoas')
    }
  }

  novoEndereco = async () => {
    this.setState({labelModal: 'Cadastrar Endereço'});
    this.setState({tipoEndereco: null});
    this.setState({endereco: ''});
    this.setState({cep: ''});
    this.setState({bairro: ''});
    this.setState({complemento: ''});
    this.setState({openSpinner: true});
    this.setState({estado: null});
    this.setState({cidade: null});
    await this.listarEstados();
    this.setState({openSpinner: false});
    this.abrirModal('modalEndereco');
  }

  adicionarEndereco = () => {

    if(this.state.cidade == null) {
      this.toast.show({severity:'error', summary: 'Endereço', detail:'Informe a cidade', life: 4000});
      return;
    }

    var tipoEndereco = '';
    if(this.state.tipoEndereco != null) {
      tipoEndereco = this.state.tipoEndereco.codigo;
    }

    let enderecos = this.state.enderecos;
    const endereco = {
      endereco: this.state.endereco,
      cep: this.state.cep,
      bairro: this.state.bairro,
      complemento: this.state.complemento,
      cidade: this.state.cidade,
      tipoEndereco: tipoEndereco
    };

    enderecos.push(endereco);
    this.setState({enderecos: enderecos});
    this.fecharModalCadastro('modalEndereco');
  }

  excluirEndereco(enderecoParaRemover) {
    this.setState((prevState) => ({
      enderecos: prevState.enderecos.filter(
        (endereco) => endereco !== enderecoParaRemover
      ),
    }));
  }

  excluirContato(contatoRemover) {
    this.setState((prevState) => ({
      contatos: prevState.contatos.filter(
        (contato) => contato !== contatoRemover
      ),
    }));
  }


  novoContato = () => {
    this.setState({tipoContato: null});
    this.setState({contatoTelefonico: ''});
    this.setState({email: ''});
    this.setState({labelModal: 'Incluir Contato'});
    this.abrirModal('modalContato');
  }

  adcionarContato = () => {
    if(this.state.tipoContato == null) {
      this.toast.show({severity:'error', summary: 'Contato', detail:'Informe o tipo de contato', life: 5000});
      return;
    }

    if(this.state.contatoTelefonico == '') {
      this.toast.show({severity:'error', summary: 'Contato', detail:'Informe o contato', life: 5000});
      return;
    }

    var contatos = this.state.contatos;
    const contato = {
      tipoTelefone: this.state.tipoContato.codigo,
      telefone: this.state.contatoTelefonico,
      email: this.state.email
    }

    contatos.push(contato);
    this.setState({contatos: contatos});
    this.fecharModalCadastro('modalContato');
  }

  abrirModal(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  render() {
    const { upLoadFiles } = this.state;
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <div className="content-wrapper">
          <div className="container-fluid">
            <section className="content-header">
              <div className="card card-primary card-outline">
                <div className="card-header">
                  <h3 className="card-title">
                    <i className="fas fa-user-tie"></i>
                    <span> Cadastrar Pessoas</span>
                  </h3>  
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-2">
                      <div className="form-group">
                        <label>Tipo de Pessoa<span className="obrigatorioAsterisco"> *</span></label>
                        &nbsp;
                        <div className="row">
                          <RadioButton inputId="tipoPessoaFisica" 
                                       name="tipoPessoa" 
                                       value="F" 
                                       onChange={this.onChangeTipoPessoa} 
                                       checked={this.state.tipoPessoa === 'F'} />
                          &nbsp;&nbsp;
                          <label htmlFor="tipoPessoaFisica">Física</label>
                          &nbsp;&nbsp;
                          <RadioButton inputId="tipoPessoaJuridica" 
                                      name="tipoPessoa" 
                                      value="J" 
                                      onChange={this.onChangeTipoPessoa} 
                                      checked={this.state.tipoPessoa === 'J'} />
                          &nbsp;&nbsp;
                          <label htmlFor="tipoPessoaJuridica">Jurídica</label>
                        </div>
                        
                      </div>
                    </div>
                  </div>
                  <TabView className="tabview-custom">
                    <TabPanel header="Informações Pessoais">
                      <div className="row">
                        <div className="col-sm-10">
                          <div className="form-group">
                            <label>{this.state.labelNome}<span className="obrigatorioAsterisco"> *</span></label>
                            <InputText id="nome"
                                      autoComplete="nope"
                                      type="text" 
                                      style={{width: '100%', height: '32px'}}
                                      value={this.state.nome}
                                      onChange={e => this.setState({nome: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Perfil Pessoa<span className="obrigatorioAsterisco"> *</span></label>
                            <Dropdown value={this.state.perfil} 
                                      options={this.state.perfis} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      onChange={this.onChangePerfil}
                                      id="perfilPessoa"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Unidade de Atendimento</label>
                            <Dropdown value={this.state.unidade} 
                                      options={this.state.unidades} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      onChange={e => this.setState({unidade: e.target.value})}
                                      id="unidadeId"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-10">
                          <div className="form-group">
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              <label style={{ fontWeight: "bold" }}>Endereço</label>
                              <i
                                className="pi pi-plus"
                                style={{
                                  color: "#2563eb", // azul
                                  fontSize: "16px",
                                  cursor: "pointer"
                                }}
                                title="Adicionar endereço"
                                onClick={this.novoEndereco}
                              ></i>
                            </div>
                            <div>
                              {this.state.enderecos && this.state.enderecos.length > 0 ? (
                                this.state.enderecos.map((endereco, index) => {
                                  // Monta dinamicamente apenas os campos existentes
                                  const partes = [
                                    endereco.tipoEndereco,
                                    endereco.endereco,
                                    endereco.bairro,
                                    endereco.cep,
                                    endereco.complemento,
                                    endereco.cidade?.nome,
                                    endereco.cidade?.estado?.estado,
                                  ].filter(Boolean); // remove undefined, null e string vazia

                                  return (
                                    <div
                                      key={index}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        padding: "8px",
                                        borderBottom: "1px solid #ddd",
                                      }}
                                    >
                                      {/* String formatada apenas com os valores existentes */}
                                      <span>{partes.join(" - ")}</span>

                                      {/* Ícones de ação */}
                                      <div style={{ display: "flex", gap: "10px" }}>
                                        <span
                                          style={{ cursor: "pointer", color: "#dc2626" }}
                                          title="Excluir"
                                          onClick={() => this.excluirEndereco(endereco)}
                                        >
                                          🗑️
                                        </span>
                                      </div>
                                    </div>
                                  );
                                })
                              ) : (
                                <p style={{ fontSize: "14px", color: "#666" }}>Nenhum endereço cadastrado</p>
                              )}
                            </div> 
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-10">
                          <div className="form-group">
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              <label style={{ fontWeight: "bold" }}>Contato</label>
                              <i
                                className="pi pi-plus"
                                style={{
                                  color: "#2563eb", // azul
                                  fontSize: "16px",
                                  cursor: "pointer"
                                }}
                                title="Adicionar Contato"
                                onClick={this.novoContato}
                              ></i>
                            </div>
                            <div>
                              {this.state.contatos && this.state.contatos.length > 0 ? (
                                this.state.contatos.map((contato, index) => {
                                  // Monta dinamicamente apenas os campos existentes
                                  const partes = [
                                    contato.tipoTelefone,
                                    contato.telefone,
                                    contato.email,
                                  ].filter(Boolean); // remove undefined, null e string vazia

                                  return (
                                    <div
                                      key={index}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        padding: "8px",
                                        borderBottom: "1px solid #ddd",
                                      }}
                                    >
                                      {/* String formatada apenas com os valores existentes */}
                                      <span>{partes.join(" - ")}</span>

                                      {/* Ícones de ação */}
                                      <div style={{ display: "flex", gap: "10px" }}>
                                        <span
                                          style={{ cursor: "pointer", color: "#dc2626" }}
                                          title="Excluir"
                                          onClick={() => this.excluirContato(contato)}
                                        >
                                          🗑️
                                        </span>
                                      </div>
                                    </div>
                                  );
                                })
                              ) : (
                                <p style={{ fontSize: "14px", color: "#666" }}>Nenhum contato cadastrado</p>
                              )}
                            </div> 
                          </div>
                        </div>
                      </div>

                      {/**Adicionar Endereço */}
                      <Dialog header={this.state.labelModal}
                              visible={this.state.modalEndereco} 
                              style={{ width: '50vw' }} 
                              footer={
                                <div>
                                  <Button label="Salvar" 
                                          className="p-button-success p-button-text"
                                          onClick={this.adicionarEndereco}/>
                                  &nbsp;
                                  <Button label="Fechar" 
                                          className="p-button-secondary p-button-text"
                                          onClick={() => this.fecharModalCadastro('modalEndereco')}/>
                                </div>
                              }
                              onHide={() => this.fecharModalCadastro('modalEndereco')}>
                              <div className="row">
                                <div className="col-sm-12">
                                  <div className="form-group">
                                    <label>Tipo de Endereço</label>
                                    <Dropdown value={this.state.tipoEndereco} 
                                              options={this.tipoEndereco} style={{width: '100%', height: '32px'}}
                                              optionLabel="nome" 
                                              onChange={e => this.setState({tipoEndereco: e.target.value})}
                                              id="tipoEndereco"
                                              className="p-inputtext-sm p-d-block p-mb-1"/>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-12">
                                  <div className="form-group">
                                    <label>Endereço</label>
                                    <InputText id="endereco" 
                                               type="text" 
                                               style={{width: '100%', height: '32px'}} 
                                               value={this.state.endereco}
                                               onChange={e => this.setState({endereco: e.target.value})}
                                               className="p-inputtext-sm p-d-block p-mb-1"/>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-4">
                                  <div className="form-group">
                                    <label>CEP</label>
                                    <InputMask
                                      id="cep"
                                      type="text"
                                      mask="99999-999"
                                      style={{ width: "100%", height: "32px" }}
                                      value={this.state.cep}
                                      onChange={e => this.setState({cep: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                                  </div>
                                </div>
                                <div className="col-sm-8">
                                  <div className="form-group">
                                    <label>Bairro</label>
                                    <InputText id="bairro" 
                                               type="text" 
                                               style={{width: '100%', height: '32px'}} 
                                               value={this.state.bairro}
                                               onChange={e => this.setState({bairro: e.target.value})}
                                               className="p-inputtext-sm p-d-block p-mb-1"/>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-12">
                                  <div className="form-group">
                                    <label>Complemento</label>
                                    <InputText id="complemento" 
                                               type="text" 
                                               style={{width: '100%', height: '32px'}} 
                                               value={this.state.complemento}
                                               onChange={e => this.setState({complemento: e.target.value})}
                                               className="p-inputtext-sm p-d-block p-mb-1"/>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-4">
                                  <div className="form-group">
                                    <label>Estado</label>
                                    <Dropdown value={this.state.estado} 
                                              options={this.state.estados} style={{width: '100%', height: '32px'}}
                                              optionLabel="estado"
                                              filter showClear filterBy="estado"
                                              onChange={this.onChangeEstado}
                                              id="estado"
                                              className="p-inputtext-sm p-d-block p-mb-1"/>
                                  </div>
                                </div>
                                <div className="col-sm-8">
                                  <div className="form-group">
                                    <label>Cidade</label>
                                    <Dropdown value={this.state.cidade} 
                                              options={this.state.cidades} style={{width: '100%', height: '32px'}}
                                              optionLabel="nome"
                                              filter showClear filterBy="nome"
                                              onChange={e => this.setState({cidade: e.target.value})}
                                              id="cidade"
                                              emptyMessage="Nenhuma Cidade"
                                              className="p-inputtext-sm p-d-block p-mb-1"/>
                                  </div>
                                </div>
                              </div>
                      </Dialog>
                      {/**Adicionar Contato */}
                      <Dialog header={this.state.labelModal}
                              visible={this.state.modalContato} 
                              style={{ width: '40vw' }} 
                              footer={
                                <div>
                                  <Button label="Salvar" 
                                          className="p-button-success p-button-text"
                                          onClick={this.adcionarContato}/>
                                  &nbsp;
                                  <Button label="Fechar" 
                                          className="p-button-secondary p-button-text"
                                          onClick={() => this.fecharModalCadastro('modalContato')}/>
                                </div>
                              }
                              onHide={() => this.fecharModalCadastro('modalContato')}>
                              <div className="row">
                                <div className="col-sm-4">
                                  <div className="form-group">
                                    <label>Tipo de Contato</label>
                                    <Dropdown
                                      value={this.state.tipoContato}
                                      options={this.tipoContato}
                                      style={{ width: "100%", height: "32px" }}
                                      optionLabel="nome"
                                      onChange={(e) => this.setState({ tipoContato: e.value })}
                                      id="tipoContato"
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                    />
                                  </div>
                                </div>

                                <div className="col-sm-8">
                                  <div className="form-group">
                                    <label>Contato</label>
                                    <InputMask
                                      id="contato2"
                                      type="text"
                                      mask={
                                        this.state.tipoContato?.nome === "CELULAR"
                                          ? "(99) 9 9999-9999"
                                          : this.state.tipoContato?.nome === "FIXO"
                                          ? "(99) 9999-9999"
                                          : this.state.tipoContato?.nome === "WHATSAPP"
                                          ? "(99) 9 9999-9999"
                                          : "99999999999999999999999"
                                      }
                                      style={{ width: "100%", height: "32px" }}
                                      value={this.state.contatoTelefonico}
                                      onChange={e => this.setState({contatoTelefonico: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-12">
                                  <div className="form-group">
                                    <label>E-mail</label>
                                    <InputText id="email" 
                                               type="text" 
                                               style={{width: '100%', height: '32px'}} 
                                               value={this.state.email}
                                               onChange={e => this.setState({email: e.target.value})}
                                               className="p-inputtext-sm p-d-block p-mb-1"/>
                                  </div>
                                </div>
                              </div>
                      </Dialog>


                      <div className="row">
                        <div className="col-sm-10">
                          <div className="form-group">
                            <label>Observação</label>
                            <InputTextarea id="observacao" 
                                           type="text" 
                                           style={{width: '100%'}} 
                                           value={this.state.observacao}
                                           onChange={e => this.setState({observacao: e.target.value})}
                                           className="p-inputtext-sm p-d-block p-mb-1"
                                           rows={12} cols={30}/>
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel header="Informações Complementares">
                    <span style={this.state.defineTipoPessoa}>
                      <div className="row">
                        <div className="col-sm-2">
                          <div className="form-group">
                            <label>Dt. Nasc.</label>
                            <Calendar id="mask" 
                                      value={this.state.dataNascimento} 
                                      onChange={(e) => this.setState({ dataNascimento: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"/>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Profissão</label>
                            <InputText id="profissao" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}}
                                        value={this.state.profissao}
                                        onChange={e => this.setState({profissao: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Atividade Econômica</label>
                            <InputText id="atividadeEconomica" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.atividadeEconomica}
                                      onChange={e => this.setState({atividadeEconomica: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-2">
                          <div className="form-group">
                            <label>Estado Civil</label>
                            <Dropdown value={this.state.estadoCivil} 
                                      options={this.state.estadosCivil} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      onChange={this.onChangeEstadoCivil}
                                      id="cidade"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Naturalidade</label>
                            <InputText id="naturalidades" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.naturalidade}
                                      onChange={e => this.setState({naturalidade: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Nacionalidade</label>
                            <InputText id="naturalidades" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.nacionalidade}
                                      onChange={e => this.setState({nacionalidade: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>Nome da Mãe</label>
                            <InputText id="nomeMae" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.nomeMae}
                                      onChange={e => this.setState({nomeMae: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>Nome do Pai</label>
                            <InputText id="nomePai" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.nomePai}
                                      onChange={e => this.setState({nomePai: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                    </span>
                    <div className="row">
                     <div className="col-sm-5">
                      <div className="form-group">
                        <label>Grupo de Pessoas</label>
                        <Dropdown value={this.state.selectGrupoPessoas} 
                                  options={this.state.grupoPessoas} 
                                  onChange={this.onChangeGrupoPessoas} 
                                  optionLabel="nome" 
                                  filter showClear filterBy="nome"
                                  style={{width: '100%', height: '32px'}}
                                  className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                     </div>
                     <div className="col-sm-5">
                      <div className="form-group">
                        <label>Origem</label>
                        <Dropdown value={this.state.captador} 
                                  options={this.state.captadores} 
                                  onChange={this.onChangeCaptador} 
                                  optionLabel="nome" 
                                  filter showClear filterBy="nome"
                                  style={{width: '100%', height: '32px'}}
                                  className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                     </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label>Conta Bancária</label>
                          <Dropdown value={this.state.tipoConta} 
                                    options={this.conta} style={{width: '100%', height: '32px'}}
                                    optionLabel="nome" 
                                    onChange={this.onChangeTipoConta}
                                    id="cidade"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label>Número da Conta</label>
                          <InputText id="conta" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}}
                                    value={this.state.contaCorrente}
                                    onChange={e => this.setState({contaCorrente: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label>Variação Poupança</label>
                          <InputText id="varPoupanca" 
                                     type="text" 
                                     style={{width: '100%', height: '32px'}}
                                     value={this.state.variacaoPoupanca}
                                     onChange={e => this.setState({variacaoPoupanca: e.target.value})}
                                     className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Agência</label>
                          <InputText id="agencia" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}} 
                                    value={this.state.agencia}
                                    onChange={e => this.setState({agencia: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-3">
                        <div className="form-group">
                          <label>Banco</label>
                          <InputText id="agencia" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}} 
                                    value={this.state.banco}
                                    onChange={e => this.setState({banco: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-7">
                        <div className="form-group">
                          <label>Chave Pix</label>
                          <InputText id="pix" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.pix}
                                      onChange={e => this.setState({pix: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    </TabPanel>
                    <TabPanel header="Documentação">
                    <span style={this.state.defineTipoPessoa}>
                      <div className="row">
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>CPF</label>
                            <InputMask id="cpf" 
                                        type="text" 
                                        mask="999.999.999-99"
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.cpfCnpj}
                                        onChange={e => this.setState({cpfCnpj: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <div className="form-group">
                            <label>RG</label>
                            <InputText id="RG" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.rg}
                                        onChange={e => this.setState({rg: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <div className="form-group">
                            <label>Senha INSS</label>
                            <InputText id="senhInss" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.senhaInss}
                                        onChange={e => this.setState({senhaInss: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                    </span>
                    <span style={this.state.defineTipoPessoaJuridica}>
                      <div className="row">
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>CNPJ</label>
                            <InputMask id="cnpj" 
                                        type="text" 
                                        mask="99.999.999/9999-99"
                                        style={{width: '100%', height: '32px'}}
                                        value={this.state.cpfCnpj}
                                        onChange={e => this.setState({cpfCnpj: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                    </span>
                    <span style={this.state.defineTipoPessoa}>
                      <div className="row">
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>CNH</label>
                            <InputText id="cnh" 
                                       type="text" 
                                       style={{width: '100%', height: '32px'}} 
                                       value={this.state.cnh}
                                       onChange={e => this.setState({cnh: e.target.value})}
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>CTPS</label>
                            <InputText id="cnh" 
                                       type="text" 
                                       style={{width: '100%', height: '32px'}}
                                       value={this.state.ctps}
                                       onChange={e => this.setState({ctps: e.target.value})}
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                    </span>
                    <span style={this.state.defineTipoPessoa}>
                      <div className="row">
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>PIS</label>
                            <InputText id="cnh" 
                                       type="text" 
                                       style={{width: '100%', height: '32px'}}
                                       value={this.state.pis}
                                       onChange={e => this.setState({pis: e.target.value})}
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>Passaporte</label>
                            <InputText id="cnh" 
                                       type="text" 
                                       style={{width: '100%', height: '32px'}}
                                       value={this.state.passaporte}
                                       onChange={e => this.setState({passaporte: e.target.value})}
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                    </span>
                    <span style={this.state.defineTipoPessoa}>
                      <div className="row">
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>Título de Eleitor</label>
                            <InputText id="cnh" 
                                       type="text" 
                                       style={{width: '100%', height: '32px'}}
                                       value={this.state.tituloEleitor}
                                       onChange={e => this.setState({tituloEleitor: e.target.value})}
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>Certidão de Reservista</label>
                            <InputText id="cnh" 
                                       type="text" 
                                       style={{width: '100%', height: '32px'}} 
                                       value={this.state.reservista}
                                       onChange={e => this.setState({reservista: e.target.value})}
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                    </span>
                    </TabPanel>
                    <TabPanel header="Arquivos">
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">  
                            <div className="container2">
                              
                              <Upload onUpload={this.handleUpload}/>
                              {!!upLoadFiles && (
                                <FileList files={upLoadFiles} onDelete={this.handleDelete}/>
                              )}
                            
                            </div>
                          </div>
                        </div>
                      </div>
                      <DataTable value={this.state.arquivos} paginator responsiveLayout="scroll" size="small"
                                  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                  currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}
                                  emptyMessage="Nenhum Arquivo">
                        <Column field="arquivo" header="Arquivo"/>
                        <Column field="descricao" header="Descrição"/>
                        <Column body={this.acoesArquivos} exportable={false} style={{ minWidth: '8rem' }} header="Ações"/>
                      </DataTable> 
                      {/**Adicionar descrição ao arquivo */}
                      <Dialog header="Descrição do Arquivo"
                                  visible={this.state.modalDescricaoArquivo} 
                                  style={{ width: '40vw' }} 
                                  footer={this.renderFooterDescricaoArquivo('modalDescricaoArquivo')}
                                  onHide={() => this.fecharModalCadastro('modalDescricaoArquivo')}>

                            <div className="row">
                              <div className="col-sm-12">
                                <div className="form-group">
                                  <label htmlFor="descricaoArquivo">Descrição</label>
                                  <InputText id="descricaoArquivo" 
                                        type="text" 
                                        style={{width: '100%', height: '37px'}} 
                                        value={this.state.descricao}
                                        onChange={e => this.setState({descricao: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                                </div>
                              </div>
                            </div>
                      </Dialog>
                      <ConfirmDialog visible={this.state.visibleExcluirArquivo} 
                                    onHide={() => this.setState({ visibleExcluirArquivo: false })} 
                                    message="Are you sure you want to proceed?"
                                    header="Confirmation"
                                    icon="pi pi-exclamation-triangle" 
                                    accept={() => this.excluirArquivo} 
                                    reject={() => this.setState({visibleExcluirArquivo: false})}/>    
                    </TabPanel>
                  </TabView>
                </div>
              </div>
              <div className="card">
                <div className="row">
                  <div className="col-sm-11">
                    <div className="form-group">  
                      <div style={{textAlign: 'right'}}>
                        <Button label="Cadastrar" 
                                className="p-button-primary p-button-text"
                                onClick={this.cadastrarPessoa}/> 
                        &nbsp;
                        <Button label="Limpar" 
                                className="p-button-secondary p-button-text"
                                onClick={this.limparCamposCadastro}/>
                        &nbsp;
                        <Button label="Voltar" 
                            className="p-button-secondary p-button-text"
                            onClick={this.voltar}/>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </>
    )
  }
}
CadastrarPessoa.contextType = AuthContext;
export default withRouter(CadastrarPessoa)